import * as allGreen from "./allGreen";
import * as lowData from "./lowData";
import * as uninstalled from "./uninstalled";
import * as expired from "./expired";
import * as empty from "./empty";
import * as multiplePackages from "./multiplePackages";
import * as unlimited from "./unlimited";
import * as credits from "./credits";

const SCENARIOS = {allGreen, lowData, uninstalled, expired, empty, multiplePackages, unlimited, credits};

// Switch which demo state mock mode serves - change this one line and save,
// no other wiring needed.
const ACTIVE_SCENARIO: keyof typeof SCENARIOS = "allGreen";

export const getMockCustomerProfile = () => SCENARIOS[ACTIVE_SCENARIO].getMockCustomerProfile();
export const getMockEsimData = () => SCENARIOS[ACTIVE_SCENARIO].getMockEsimData();
